export const vampirioSiteUrl = 'https://vampirio.app'
